import { atomFamily, selector } from "recoil";
import { SDKState } from "./SDKStates";

export const breakpoints = {
	xs: 0,
	sm: 768,
	md: 1024,
	lg: 1240,
	xl: 1440,
};

export const responsiveState = atomFamily({
	key: "responsive",
	default: (size = "md") => (typeof window !== "undefined" ? document.body.clientWidth < breakpoints[size] : false),
});


export const userBrowserInfoState = selector({
	key: "userBrowserInfo",
	get: ({get}) => {
		const sdk = get(SDKState);
		return sdk.get("/client-info").then(res => ({
			ip: res.ip,
			uag: res.agent
		}));
	}
});

export const userBlockedBrowserInfoState = selector({
	key: "userBlockedBrowserInfo",
	get: ({get}) => {
		try {
			get(userBrowserInfoState);
			return false;
		} catch {
			return true;
		}
	}
});

export const userIPState = selector({
	key: "userIP",
	get: ({get}) => {
		const browserInfo = get(userBrowserInfoState);
		return browserInfo.ip;
	}
});


export const userBrowserUserAgentState = selector({
	key: "userBrowserUserAgent",
	get: ({get}) => {
		const browserInfo = get(userBrowserInfoState);
		return browserInfo.uag;
	}
});
